export const SET_QUESTION_FORM = "SET_QUESTION_FORM";

export const setQuestionForm = (questionForm) => ({
  type: SET_QUESTION_FORM,
  payload: questionForm,
});
